/* eslint-disable spire/export-styles */

import React, { FC } from "react";
import styled, { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Info from "@insite/mobius/Icons/Info";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import CustomTable from "@theStellarBlueprint/Common/CustomCommonTableContainer";

type Props = WidgetProps;

export interface LocationStyles {
    link?: InjectableCss;
    modal?: InjectableCss;
    tableContainer?: InjectableCss;
}

const styles: LocationStyles = {
    link: {
        css: css`
            font-size: 14px;
            line-height: 24px;
            margin: 10px 0;
            &:focus {
                outline: 0;
            }
            & span[class^="TypographyStyle"] {
                display: flex;
                align-items: center;
                color: ${getColor("secondary.main")};
                font-weight: 400;
                &:hover {
                    color: #008061;
                    font-weight: 600;
                }
                & span {
                    margin-right: 5px;
                    svg {
                        color: #008061;
                        width: 20px;
                    }
                }
            }
        `,
    },
};

export const locationStyles = styles;

const LocationAvailability: FC<Props> = ({ id }) => {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const shareLinkClickHandler = () => {
        setModalIsOpen(true);
    };

    return (
        <>
            <Link {...styles.link} onClick={shareLinkClickHandler} data-test-selector="productShareLink">
                <Icon src={Info}></Icon> Location Availability
            </Link>
            <Modal
                {...styles.modal}
                headline={translate("Location Availability")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
                sizeVariant="small"
            >
                <CustomTable tableType="bordered">
                    <table>
                        <thead>
                            <tr>
                                <th>Location</th>
                                <th>Availability</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Thane</td>
                                <td>56</td>
                            </tr>
                            <tr>
                                <td>Mumbai</td>
                                <td>16</td>
                            </tr>
                        </tbody>
                    </table>
                </CustomTable>
            </Modal>
        </>
    );
};

const location: WidgetModule = {
    component: LocationAvailability,
    definition: {
        group: "Common",
        icon: "Location",
    },
};

export default location;
